import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, setPersistence, browserLocalPersistence, GoogleAuthProvider } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyDecwagCvzvRLfC5KiOo6W3X8St7J3kT7M",
  authDomain: "event-management-swg.firebaseapp.com",
  projectId: "event-management-swg",
  storageBucket: "event-management-swg.firebasestorage.app",
  messagingSenderId: "859404817183",
  appId: "1:859404817183:web:43cb71db64fa66ee02d62a"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const functions = getFunctions(app);
const projectId = firebaseConfig.projectId;
const realtimeDb = getDatabase();

// Ensure the user session persists across refresh
setPersistence(auth, browserLocalPersistence);

//export default db;

export { db, auth, googleProvider, functions, projectId, realtimeDb, httpsCallable};